










































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const changePassword = namespace("changePassword");
const login = namespace("login");
const root = namespace("root");

@Component
export default class ChangePassword extends Vue {
  @root.Action getSystemValue;

  @changePassword.Action changePasswordFn;
  ruleForm: any = {
    originalPassword: "",
    newPassword: "",
    password: ""
  };

  rules: any = {
    originalPassword: [
      {
        required: true,
        validator: this.validateOriginPassword,
        trigger: "blur"
      }
    ],
    newPassword: [
      { required: true, validator: this.validatePass, trigger: "blur" }
    ],
    password: [
      { required: true, validator: this.validatePass2, trigger: "blur" }
    ]
  };
  loading: boolean = false;
  account = "";
  timer: any = null;
  errorMsg = "";
  pwdTipValue = "";

  @login.Action logout;

  created() {
    this.getPwdTip();
    this.account = localStorage.getItem("account");
  }

  async getPwdTip() {
    let res = await this.getSystemValue({
      valueCode: "WT_PWD_TIP"
    });
    this.pwdTipValue = res.valueValue || "";
  }
  async handleSubmit() {
    try {
      this.loading = true;
      await this.handleVaild();
      try {
        let res = await this.changePasswordFn({
          oldPassword: this.ruleForm.originalPassword,
          password: this.ruleForm.password
        });
        await this.logout();
        this.$router.push({ name: "changePasswordSuccess" });
      } catch (error) {
        let { graphQLErrors } = error;
        if (graphQLErrors && graphQLErrors[0]) {
          this.errorMsg = graphQLErrors[0].message;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  }

  async handleVaild() {
    return new Promise((resolve, reject) => {
      const $form: any = this.$refs["ruleForm"];
      $form.validate(valid => {
        valid ? resolve("") : reject("填写错误");
      });
    });
  }
  validatePass(rule, value, callback) {
    // 字母和数字，6位以上
    let pattern = /^(?=.*[a-zA-Z])(?=.*\d)[\S]+$/;
    console.log(value, "value");
    if (value === "") {
      let error: any = "密码不能为空";
      callback(new Error(error));
    } else if (value.length < 6 || value.length > 20) {
      let error: any = "密码长度必须为6-20字符";
      callback(new Error(error));
    } else if (!pattern.test(value)) {
      let error: any = "密码必须包含大小写字母和数字";
      callback(new Error(error));
    } else if (value.indexOf(this.account) !== -1) {
      let error: any = "密码不能包含用户名";
      callback(new Error(error));
    } else {
      callback();
    }
  }
  validatePass2(rule, value, callback) {
    if (value === "") {
      let error: any = "密码不能为空";
      callback(new Error(error));
    } else if (value !== this.ruleForm.newPassword) {
      let error: any = "两次输入密码不一致";
      callback(new Error(error));
    } else {
      callback();
    }
  }
  validateOriginPassword(rule, value, callback) {
    if (value === "") {
      let error: any = "请填写当前密码";
      callback(new Error(error));
    } else {
      callback();
    }
  }

  isFocus = false;
  focusInput(prop) {
    this.isFocus = true;
    this.focurClear(prop);
  }
  focurClear(prop) {
    const $form: any = this.$refs["ruleForm"];
    $form && $form.clearValidate(prop);
  }
  blurInput() {
    this.isFocus = false;
  }
  originPasswordType = true;
  newPasswordType = true;
  againPasswordType = true;
  triggerPassword(passwordType) {
    this[passwordType] = !this[passwordType];
  }
  backRouteFn() {
    this.$router.go(-1);
  }
}
